import { Container, Text, Title, Paper } from "@mantine/core";

const PaymentCancelled = () => (
  <Container size="sm" ta="center">
    <Paper mt="xl" p="lg" withBorder>
      <Title mb="xl" order={2}>
        Payment Cancelled
      </Title>
      <Text>Your payment was cancelled, no money was deducted.</Text>
      <Text mt="xl">
        Please get in touch with{" "}
        <a href="mailto:support@photovortex.com">support@photovortex.com</a> if
        you have any trouble with the payment!
      </Text>
    </Paper>
  </Container>
);

export default PaymentCancelled;
